import { EditRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { IdentifiedFieldIssue } from '../../IFITrackerContext/types'
import { IFIStatus, Permission } from '@cims-online/shared'
import CustomFieldEditor from 'components/CustomFields/CustomFieldEditor'
import { useProjectCustomFieldsContext } from 'components/CustomFields/ProjectCustomFieldsContext'
import { CustomFieldEditorValues } from 'components/CustomFields/CustomFieldEditor/types'
import { useIFITrackerContext } from '../../IFITrackerContext'
import ReviewNotesFormItem from '../../components/ReviewNotesFormItem'
import { ReviewNotesFormItemValues } from '../../components/ReviewNotesFormItem/types'
import { toLabeledValues } from 'components/CIMSSelect/utils/labeledValues'
import IssueSelect from './components/IssueSelect'
import { IssueSelectValues } from './components/IssueSelect/types'
import EJSelect from './components/EJSelect'
import { EJSelectValues } from './components/EJSelect/types'

export function useEdit(): EditRowActionOptions<
  IdentifiedFieldIssue,
  CustomFieldEditorValues &
    ReviewNotesFormItemValues &
    IssueSelectValues &
    EJSelectValues
> {
  const { toCustomFieldEditorValue, toMutateCustomFieldsInput } =
    useProjectCustomFieldsContext()
  const { refetch, edit } = useIFITrackerContext()
  return {
    permission: Permission.EditIdentifiedFieldIssue,
    modal: {
      type: 'simple',
      initialValues: ({
        reviewNotes,
        customFields,
        issues,
        engineeringJudgements,
      }) => ({
        reviewNotes,
        customFields: toCustomFieldEditorValue(customFields),
        issues: toLabeledValues(issues, {
          label: 'formattedNumber',
          value: 'id',
          tooltip: 'description',
        }),
        judgements: toLabeledValues(engineeringJudgements, {
          label: 'formattedNumber',
          value: 'id',
        }),
      }),
      body: ({ statusId }) => (
        <>
          <ReviewNotesFormItem />
          <IssueSelect statusId={statusId} />
          <EJSelect statusId={statusId} />
          <CustomFieldEditor
            hideBooleans
            alreadyDisabled={
              statusId === IFIStatus.Closed.id
                ? {
                    why: 'only status',
                    statusName: IFIStatus.PendingReview.name,
                  }
                : false
            }
          />
        </>
      ),
      onOk: async (
        { reportId },
        { customFields, reviewNotes, issues, judgements }
      ) => {
        await edit({
          variables: {
            input: {
              reportId,
              customFields: toMutateCustomFieldsInput(customFields),
              reviewNotes,
              issueIds: issues?.map(({ value }) => value.toString()),
              judgementIds: judgements?.map(({ value }) => value.toString()),
            },
          },
        })
        refetch()
      },
      recordName: ({ reportName, reportId }) => reportName ?? reportId,
    },
  }
}
